import React from 'react';
import { ButtonGroup } from 'react-bootstrap';
import { Link } from '../../../../../Router';
import { routes } from '../../../routes';
import { createTimeSheetPageQueryParams } from '.';

type Props = {
  startDate: string;
  title: string;
  previousTimeSheetStartDay: string;
  nextTimeSheetStartDay: string;
};

const Nav: React.FC<Props> = ({
  startDate,
  previousTimeSheetStartDay,
  nextTimeSheetStartDay,
  title,
}) => {
  return (
    <div className="text-end">
      <ButtonGroup size="sm" className="bg-gray rounded p-1">
        <Link
          to={routes.timeTracking.route.withQueryParams(
            createTimeSheetPageQueryParams({
              startDate: previousTimeSheetStartDay,
            }),
          )}
          className="btn btn-gray">
          ←
        </Link>
        <Link
          to={routes.timeTracking.route.withQueryParams(
            createTimeSheetPageQueryParams({
              startDate,
            }),
          )}
          className="btn btn-sm btn-white rounded">
          {title}
        </Link>
        <Link
          to={routes.timeTracking.route.withQueryParams(
            createTimeSheetPageQueryParams({
              startDate: nextTimeSheetStartDay,
            }),
          )}
          className="btn btn-gray">
          →
        </Link>
      </ButtonGroup>
    </div>
  );
};

export default Nav;
